module.exports = __webpack_public_path__ + "img/active.93681a56.svg";